import {React, useContext} from 'react'
import bg_img3 from './static/img/bg-img3.jpg'
import BreadcrumbsSection from './BreadcrumbsSection'
import OurServicesSection from './OurServicesSection'
import FeedbackSection from './FeedbackSection'
import RoutesContext from '../contexts/RoutesContext'

function Service4Page(props) {
    let routes_context = useContext(RoutesContext)
  return (
    <main onLoad={routes_context.flip_card_resize}>
        
        <BreadcrumbsSection routes={routes_context.routes} page_name='Services' />
        <div className="services_banner_section">
            <div className="services_banner_inner_wrapper">
                <img src={bg_img3} alt="" />
            </div>
        </div>

        <OurServicesSection routes={routes_context.routes} setCurrentPage = {routes_context.setCurrentPage} />

        <div className="content_section" id="content_section">
            <div className="content_inner_wrapper">
                <h1 className="service_content_title">DRAFT OF MAXIMUM PERMISSIBLE DISCHARGE</h1>
                <p>
                    Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) taslamasy Kärhana tarapyndan atmosfera çykarylýan zyýanly maddalaryň rugsat edilýän ýokary mukdaryny düzgünleşdirýän (reglamentirleýän) normatiwler. Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) görkezijisi hapalaýjynyň stasionar çeşmesi üçin, howadaky hapalaýjy maddalaryň umumy mukdaryny (düzümini) göz öňünde tutmak arkaly bellenilýär. Çeşmeden çykýan zatlaryň derejesi ekologiýanyň bellenilen normatiwlerinden aňry geçmeli däldir. Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) boýunça taslama zyýanly maddalaryň iň bolmanda, haýsydyr bir çeşmesi bar bolan islendik kärhana üçin hökman işlenip taýýarlanmalydyr. Siz <b>“Sagdyn ülke” HK</b> rugsat edilýän aňryçäk zyňyndylaryň (REAZ) boýunça taslamany işläp düzmek baradaky hyzmatyň berjaý edilmegini tabşyryp bilersiňiz.
                </p>
                <br/><br/>
                <h2>NORMATIWLER NÄDIP HASAPLANYLÝAR?</h2>
                <p>
                    Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) baradaky taslama <b>17.2.3.02-78 Tebigaty goramak. Atmosfera. Senagat kärhanalar tarapyndan zyýanly maddalaryň rugsat edilýän aňryçäk zyňyndylaryň (REAZ) kesgitlemegiň düzgünleri</b> boýunça bildirilýän talaplara laýyklykda işlenip düzülýär.
                </p>
                <p>
                    Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) ähli umumy kabul edilen formulalar boýunça hasaplanýar. Rugsat edilýän aňryçäk zyňyndylaryň (REAZ) baradaky taslamanyň normatiwleriniň kesgitlenmegine birnäçe ýagdaýlar, ýagny:
                </p>
                <p>
                    howanyň (klimatyň) we atmosferanyň aýratynlyklary, zyýanly zyňyndylaryň çeşmeleriniň ýerleşýän ýeri, landşaftyň aýratynlyklary, daşyna çykarylýan galyndylaryň himiki we fiziki häsiýetnamalary, turbalaryň agyzlarynyň diametri, turbalaryň agyzlarynyň ýeriň ýokarsyndaky belentligi öz täsirini ýetirýär. Agzalyp geçilen bu ýagdaýlaryň hersi daşyna çykarylýan galyndylaryň daş töweregine ýaýramagyna belli bir derejede täsir edýär.
                </p>
                <br/><br/>
                <h2>RUGSAT EDILÝÄN AŇRYÇÄK ZYŇYNDYLARYŇ (REAZ) BARADAKY TASLAMA NÄÇE ÝYLLAP HEREKET EDÝÄR?</h2>
                <p>
                    Şu taslama her 5 ýyldan işlenip düzülýär we ylalaşylýar hem-de bu ýagdaý ep-esli wagt dowam edýär. Zyýanly maddalaryň rugsat edilýän aňryçäk zyňyndylaryň (REAZ) gaýtadan garalmagynyň has gysga möhletiň dowamynda amala aşyrylmagyna sebäp bolýan aýratyn şertlere şular goşulýar:
                </p>
                <p>— Rugsat edilýän aňryçäk zyňyndylaryň sanyň üýtgemegi – täze çeşmeleriň döremegi ýa-da bar bolan çeşmeleriň aradan aýrylmagy;</p>
                <p>— Kärhananyň önümçilik maksatnamasynyň we kärhanada ulanylýan tehnologiýalaryň çalşyrylmagy.</p>
                <br/><br/>
                <p>
                    Bize buýurma bermek üçin, iki taraplaýyn aragatnaşyga degişli namanyň görnüşini ýazyp dolduryň ýa-da biziň elektron Contactsa hat iberiň. kärhanamyzyň menejerleri buýurma degişli ähli ýagdaýlary anyklamak üçin, siz bilen dessine habarlaşar. Şeýle hem siz “Contacts” atly bölümde görkezilen belgiler (nomerler) boýunça jaň edip bilersiňiz. Biz öz işimize degişli islendik sowala jogap bermäge elmydama taýyn.
                </p>
                <br/><br/>
                <h2 className="service_content_footer">AŞAKDA GÖRKEZILEN GÖRNÜŞDÄKI TALAPNAMANY TABŞYRYŇ ÝA-DA BIZE JAŇ EDIŇ.</h2>
            </div>
        </div>

        <FeedbackSection margin_top="margin_top" />    

    </main>
  )
}

export default Service4Page